import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { AppUtility } from "src/app/interceptor/apputitlity";
import { ApiServiceService } from "src/app/api-service.service";
@Component({
  selector: 'app-msme-form',
  templateUrl: './msme-form.component.html',
  styleUrls: ['./msme-form.component.scss']
})
export class MsmeFormComponent implements OnInit {
  // Variables Defined
  msmeForm!: FormGroup;
  formSubmitted = false;
  showFields = false;
  isLoading = false;
  isSubmitting = false;
  show=false;;
  vendorId: any;
  supplierData: any;
  msmeRecords: any[] = [];
  msmeError = "";

  constructor(
    private fb: FormBuilder,
    private _utility: AppUtility,
    private route: ActivatedRoute,
    private _apiService: ApiServiceService,
  ) {}

  ngOnInit(): void {
    this.initializeForm();
    this.loadSupplierData();
  }
  // Initial Form Values
  initializeForm(): void {
    this.msmeForm = this.fb.group({
      msmeRegistered: ["", Validators.required],
      vendorName: [""],
      supplierCode: [""],
      gstNumber: [""],
       udyamNumber: [
    '',
    [
      Validators.required,
      Validators.pattern(/^UDYAM-[A-Z]{2}-\d{2}-\d{7}$/)
    ]
  ],
      activityType: [""],
      enterpriseType: [""],
      phone: [""],
      email: [""],
      documentUpload: [""],
      
    });
  }
// Add both helpers to the component class

getInputValue(event: Event): string {
  return (event.target as HTMLInputElement).value;
}

// Separate helper for column filters — avoids ANY string literals in template
onFilter(event: Event, table: any, field: string): void {
  table.filter(this.getInputValue(event), field, 'contains');
}
  // Supplier Data API called
  loadSupplierData(): void {
    this.route.queryParams.subscribe((params) => {
      // Vendor Id from the URL is taken (accept uppercase or lowercase)
      this.vendorId = params["Id"] || params["id"];
      console.log("Vendor ID from URL:", this.vendorId);
      if (this.vendorId) {
        this.getSupplierById();
        const filter = { supplierId: this.vendorId };

        // fetch any existing MSME forms for this supplier
        this._apiService
          .getMsmeForms(filter)
          .then((res) => {
            console.log("msmeForms response", res);
            this.msmeRecords = res.returnValue || [];
            console.log('msmeRecords array now:', this.msmeRecords);
          })
          .catch((err) => {
            console.error(err);
            this.msmeError = "load failed";
          });

        // optionally keep the old commented example around
        // this._apiService.getMsmeForms({ supplierId: this.vendorId })
        //   .then(res => console.log('MSME forms', res));
      }
    });
  }
  // API method to get the supplier by ID
  getSupplierById(): void {
    console.log("   API Endpoint: /api/msme-save-form/" + this.vendorId);

    this._apiService
      .getmsmesupplier(this.vendorId)
      .then((res: any) => {
        this._utility.loader(false);
        this.isLoading = false;
        console.log("✓ Step 4: API Response Received:", res);
  
        if (res.success) {
          this.supplierData = res.returnValue;
          console.log(this.supplierData);
          
          this.autoFillFormFields();
        } else {
          this._apiService.showMessage("Failed to load supplier data", "error");
        }
      })
      .catch((err: any) => {
        this._utility.loader(false);
        this.isLoading = false;
        console.error("❌ ERROR: API Call Failed!");
        console.error("   Error Details:", err);
        console.error("   Vendor ID attempted:", this.vendorId);
        this._apiService.showMessage(
          "Error loading supplier information - Vendor ID may not exist",
          "error",
        );
      });
  }

  //  To auto-fill the form fields
  autoFillFormFields(): void {
    if (!this.supplierData) return;

    const fillData: any = {};

    //  Correct field names from supplier API response
    fillData.vendorName = this.supplierData.supplierName || "";
    fillData.supplierCode = this.supplierData.jdeNo || "";
    fillData.gstNumber = this.supplierData.gstinNo || "";
    fillData.phone = this.supplierData.mobileNo || "";
    fillData.email = this.supplierData.emailAddress || "";

    // These may or may not exist — fallbacks kept
    // fillData.udyamNumber = this.supplierData.msmeNo || this.supplierData.udyamNumber || "";
    // fillData.activityType = this.supplierData.activityType || "";
    // fillData.enterpriseType = this.supplierData.enterpriseType || "";

    console.log("Auto-fill data:", fillData);
    this.msmeForm.patchValue(fillData);
  }
  // To get the file
  getFile(event: any): void {
    const file = this._utility.onFileChange(event);
    this.msmeForm.controls["documentUpload"].setValue(file);
    console.log("File captured:", file);
  }
  // To handle the change event of the MSME registered field
 onMsmeChange(value: any): void {

  const yesFields = [
    "supplierCode",
    "udyamNumber",
    "activityType",
    "enterpriseType",
    "phone",
    "documentUpload"
  ];

  if (value === "Yes") {

    this.showFields = true;

    yesFields.forEach((field) => {
      this.msmeForm.get(field)?.setValidators([Validators.required]);
      this.msmeForm.get(field)?.updateValueAndValidity();
    });

    // Email validation
    this.msmeForm.get("email")?.setValidators([
      Validators.required,
      Validators.email
    ]);
    this.msmeForm.get("email")?.updateValueAndValidity();

    // Udyam format validation
    this.msmeForm.get("udyamNumber")?.setValidators([
      Validators.required,
      Validators.pattern(/^UDYAM-[A-Z]{2}-\d{2}-\d{7}$/)
    ]);
    this.msmeForm.get("udyamNumber")?.updateValueAndValidity();

    if (this.supplierData) {
      this.autoFillFormFields();
    }

  } 
  
  else if (value === "No") {

    this.showFields = false;

    // Clear MSME specific validators
    [
      "vendorName",
      "supplierCode",
      "udyamNumber",
      "activityType",
      "enterpriseType",
      "documentUpload"
    ].forEach((field) => {
      this.msmeForm.get(field)?.clearValidators();
      this.msmeForm.get(field)?.updateValueAndValidity();
    });

    // Phone still required
    this.msmeForm.get("phone")?.setValidators([
      Validators.required,
      Validators.pattern(/^[6-9]\d{9}$/)
    ]);
    this.msmeForm.get("phone")?.updateValueAndValidity();

    // Email still required
    this.msmeForm.get("email")?.setValidators([
      Validators.required,
      Validators.email
    ]);
    this.msmeForm.get("email")?.updateValueAndValidity();

    // Reset MSME specific fields
    this.msmeForm.patchValue({
      udyamNumber: "",
      activityType: "",
      enterpriseType: "",
      documentUpload: ""
    });

  }
}
  // To submit the form
  submitMsmeForm(): void {
    this.formSubmitted = true;

    console.log("Form submission initiated");
    console.log("Form value:", this.msmeForm.value);

    if (this.msmeForm.invalid) {
      this.msmeForm.markAllAsTouched();
      console.log("Form is invalid");
      this._apiService.showMessage(
        "Please fill all required fields correctly",
        "error",
      );
      return;
    }
    // To set the form as submitting
    this.isSubmitting = true;

    // Map form data to API model
    const msmePayload = {
      isActive: true,
      clientId: 0,
      id: 0,
      crDate: new Date().toISOString(),
      statementType: "MSME",
      supplierId: this.vendorId ? parseInt(this.vendorId) : 0,
      msmeRegistered: this.msmeForm.get("msmeRegistered")?.value === "Yes",
      vendorName: (this.msmeForm.get("vendorName")?.value || "").toString(),
      supplierCode: (this.msmeForm.get("supplierCode")?.value || "").toString(),
      gstinNumber: (this.msmeForm.get("gstNumber")?.value || "").toString(),
      msmeNumber: (this.msmeForm.get("udyamNumber")?.value || "").toString(),
      typeOfActivity: (
        this.msmeForm.get("activityType")?.value || ""
      ).toString(),
      typeOfEnterprise: (
        this.msmeForm.get("enterpriseType")?.value || ""
      ).toString(),
      phoneNumber: (this.msmeForm.get("phone")?.value || "").toString(),
      emailAddress: (this.msmeForm.get("email")?.value || "").toString(),
      createdBy: 0,
      updatedBy: 0,
    };

    // Create FormData and append payload fields
    const formData = new FormData();
    Object.keys(msmePayload).forEach((key) => {
      const value = (msmePayload as any)[key];
      formData.append(key, value === null || value === undefined ? "" : value);
    });

    // include file if present
    const fileControl = this.msmeForm.get("documentUpload");
    if (fileControl?.value) {
      console.log("attaching file:", fileControl.value.name);
      formData.append(
        "documentUpload",
        fileControl.value,
        fileControl.value.name,
      );
    }

    // Log payload for debugging
    console.log("========== MSME FORM SUBMISSION INITIATED ==========");
    console.log(
      " Submitting to Endpoint: POST /api/supplier/save-msme-form (FormData)",
    );
    formData.forEach((v, k) => console.log(`   ${k}:`, v));

    // Send FormData
    this._apiService
      .submitMsmeForm(formData)
      .then((res: any) => {
        this.isSubmitting = false;
        if (res.success) {
          this.show = true
          this._apiService.showMessage(
            "Form submitted successfully!",
            "success",
          );
          this.resetForm();
        } else {
          console.error("ERROR: Submission failed");
          console.error("   Message:", res.message);
          console.error("   Response:", res);
          this._apiService.showMessage(
            res.message || "Submission failed",
            "error",
          );
        }
      })
      .catch((err: any) => {
        this.isSubmitting = false;
        console.error("ERROR: API Call Failed!");
        console.error("   Error Reason:", err.message || err);
        console.error("   Full Error:", err);
        this._apiService.showMessage(
          "Error submitting form. Please try again.",
          "error",
        );
      });
  }
  // To reset the form
  resetForm(): void {
    this.msmeForm.reset();
    this.formSubmitted = false;
    this.showFields = false;
    this.msmeForm.patchValue({ msmeRegistered: "" });
    console.log("Form reset");
  }
}

//     this.msmeForm.reset();
//     this.formSubmitted = false;
//     this.showFields = false;
//     this.msmeForm.patchValue({ msmeRegistered: "" });
//     console.log("Form reset");
//   }
// }
